"use client";

import { c as _c } from "react/compiler-runtime";
import { deleteComment } from "@/actions/comment";
import { AlertDialog, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import ButtonWithLoader from "@/components/utility/button-with-loader";
import { queryClient } from "@/providers/react-query";
import { TComment, TContentType } from "@/types/types";
import { tryCatch } from "@/utils/validators";
import { MoreHorizontal, Trash } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
type CommentMenuProps = {
  contentType: TContentType;
  contentId: string;
  comment: TComment;
};
export default function CommentMenu(t0) {
  const $ = _c(16);
  const {
    contentType,
    contentId,
    comment
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  let t1;
  if ($[0] !== comment.id || $[1] !== contentId || $[2] !== contentType) {
    t1 = async function handleDeleteComment() {
      setIsDeleting(true);
      const {
        error
      } = await tryCatch(deleteComment(comment.id));
      if (error) {
        toast.error(error.message);
        return;
      }
      setIsDeleting(false);
      setIsOpen(false);
      queryClient.invalidateQueries({
        queryKey: [`get-comments:${contentType}:${contentId}`]
      });
      toast.success("Comment deleted.");
    };
    $[0] = comment.id;
    $[1] = contentId;
    $[2] = contentType;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleDeleteComment = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <DropdownMenuTrigger asChild={true}><Button variant="ghost" className="absolute right-2 top-0 h-8 w-8 p-0"><MoreHorizontal className="h-4 w-4" /></Button></DropdownMenuTrigger>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DropdownMenu>{t2}<DropdownMenuContent><DropdownMenuItem onClick={() => setIsOpen(true)}><Trash className="mr-2 h-4 w-4" /> Delete</DropdownMenuItem></DropdownMenuContent></DropdownMenu>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <AlertDialogHeader><AlertDialogTitle>Are you absolutely sure?</AlertDialogTitle><AlertDialogDescription>This action cannot be undone. It will permanently delete this comment.</AlertDialogDescription></AlertDialogHeader>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <AlertDialogCancel>Cancel</AlertDialogCancel>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== handleDeleteComment) {
    t6 = () => handleDeleteComment();
    $[8] = handleDeleteComment;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== isDeleting || $[11] !== t6) {
    t7 = <AlertDialogContent>{t4}<AlertDialogFooter>{t5}<ButtonWithLoader onClick={t6} pending={isDeleting}>Delete</ButtonWithLoader></AlertDialogFooter></AlertDialogContent>;
    $[10] = isDeleting;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== isOpen || $[14] !== t7) {
    t8 = <>{t3}<AlertDialog open={isOpen} onOpenChange={setIsOpen}>{t7}</AlertDialog></>;
    $[13] = isOpen;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
}